import React, { useEffect, useState } from "react";
import Header from "./Header";
import { Link } from "react-router-dom";

function People(props) {
    /* team data */
    const staffData = [
        {
            id: 1,
            image: "/images/staf/people-ceo.png",
            name: "Ko, Hojun",
            position: "CEO",
            description: "건축의 시작이,\n더 이상 전문가만의 영역이 아니길 바란다.",
            hashtag: "#건축가 #창업가 #유튜버"
        },
        {
            id: 2,
            image: "/images/staf/MjuwonB.jpg",
            name: "Yoon, Laye",
            position: "CMO",
            description: "나는 방향을 설계하고,\n팀은 파도를 만든다.",
            hashtag: "#분위기메이커 #햇살캐 #꺄르르"
        },
        {
            id: 3,
            image: "/images/staf/dongukB.jpg",
            name: "Kim, Donguk",
            position: "CSO",
              description: "설계는 정답이 없지만 오답은 있다.",
            hashtag: "#건축가 #궁수 #클라이머"
        },
        {
            id: 4,
            image: "/images/staf/hyungwooB.jpg",
            name: "Lee, Hyungwoo",
            position: "CTO",
            description: "불가능한 개발은 없다.\n노력이 필요할 뿐.",
            hashtag: "#풀스택 #천재개발자 #플러팅장인"
        },
        {
            id: 5,
            image: "/images/staf/yubinB.jpg",
            name: "Han, Yubin",
            position: "PM",
            description: "모든 것은 ‘기획’으로 시작된다.",
            hashtag: "#기획 #감정미적분기 #유빈씨,,바빠요?"
        },
        {
            id: 6,
            image: "/images/staf/people-Junhoe.png",
            name: "Jang, Junhoe",
            position: "Developer",
            description: "버그보다 골절이 먼저 왔다.",
            hashtag: "#풀스택 #술자바(Sul.js) #손가락404"
        },
        {
            id: 7,
            image: "/images/staf/people-Seungjin.png",
            name: "Park, Seungjin",
            position: "Developer",
            description: "데이터는 쿨하게,\n분석은 뜨겁게.",
            hashtag: "#데이터개발자 #동자승 #오픈런러"
        },
        {
            id: 8,
            image: "/images/staf/people-Soonjoo.png",
            name: "Park, Soonjoo",
            position: "Developer",
            description: "오류는 고쳐도,\n자세는 못 고친다.",
            hashtag: "#풀스택 #허리404 #래블래용"
        },
        {
            id: 9,
            image: "/images/staf/people-Nakyun.png",
            name: "Kim, Nakyung",
            position: "Designer",
            description: "디자인은 디테일,\n회식은 타이밍.",
            hashtag: "#디자이너 #회식탐지기 #피그마의광대"
        },
    ];
    return (
        <div id="Staf">
            <Header userInfo={props.userInfo} logout={props.logout} />
            <main>
                <div className="staff-container">
                    <div className="staff-grid">
                        {staffData.map((staff) => (
                            <div key={staff.id} className="staff-card">
                                <div className="staff-image">
                                    <img src={staff.image} alt={staff.name} />
                                </div>
                                <div className="staff-info">
                                    <p className="staff-name">{staff.name}<span className="staff-position">{staff.position}</span></p>
                                    <p className="staff-description">
                                        {staff.description.split('\n').map((line, i) => (
                                            <React.Fragment key={i}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </p>
                                    <p className="staff-hashtag">
                                        {staff.hashtag}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


                {/* <ul className="staf_wrap">
                    <li>
                        <h2></h2>
                        <div className="txt_box">
                            <p className="position">CEO</p>
                            <h3>고호준</h3>
                            <p className="hashtag">#ENTP #건축가<br />#감각적인디자이너 #존레논 <br />#뒷태미녀 #맛집잘알</p>
                        </div>
                    </li>
                    <li>
                        <h2></h2>
                        <div className="txt_box">
                            <p className="position">CTO</p>
                            <h3>윤주원</h3>
                            <p className="hashtag">#INFP #햎피뤂피<br />#프롭메이트의어머니 #꺄르르<br />#행복한햄스터 #분위기메이커</p>
                        </div>
                    </li>
                    <li>
                        <h2></h2>
                        <div className="txt_box">
                            <p className="position">MANAGER</p>
                            <h3>김동욱</h3>
                            <p className="hashtag">#ISTP #백바담의아버지<br />#프롭메이트의클라이머<br />#전완근29cm #사실은설계천재</p>
                        </div>
                    </li>
                    <li>
                        <h2></h2>
                        <div className="txt_box">
                            <p className="position">ENGINEER</p>
                            <h3>김종인</h3>
                            <p className="hashtag">#ISTJ #교회오빠<br />
                                #클라이밍천재 #정리아티스트<br />#디자인개발둘다가능</p>
                        </div>
                    </li>
                    <li>
                        <h2></h2>
                        <div className="txt_box">
                            <p className="position">ENGINEER</p>
                            <h3>이형우</h3>
                            <p className="hashtag">#ISFP #코딩아티스트<br />#자칭이시대최고의천재개발자<br />#프롭메이트의배드민턴선수</p>
                        </div>
                    </li>
                    <li>
                        <h2></h2>
                        <div className="txt_box">
                            <p className="position">DESIGNER</p>
                            <h3>한유빈</h3>
                            <p className="hashtag">#INTP #손빠른디자이너<br />#알잘딱깔센정석 #막내이긴함<br /> #뭐든지빨리배움</p>
                        </div>
                    </li>
                    <li className="easter_egg1 easter_egg"></li>
                    <li className="easter_egg2 easter_egg"></li>
                    <li className="easter_egg3 easter_egg"></li>
                    <li className="easter_egg4 easter_egg"></li>
                    <li className="easter_egg5 easter_egg"></li>
                    <li className="easter_egg6 easter_egg"></li>
                    <li className="egg1 egg">
                        <img src={process.env.PUBLIC_URL + "images/staf/cat1.png"}></img>
                    </li>
                    <li className="egg2 egg">
                        <img src={process.env.PUBLIC_URL + "images/staf/cat2.png"}></img>
                    </li>
                    <li className="egg3 egg">
                        <img src={process.env.PUBLIC_URL + "images/staf/cat3.png"}></img>
                    </li>
                    <li className="egg4 egg">
                        <img src={process.env.PUBLIC_URL + "images/staf/cat4.png"}></img>
                    </li>
                    <li className="egg5 egg">
                        <img src={process.env.PUBLIC_URL + "images/staf/cat5.png"}></img>
                    </li>
                    <li className="egg6 egg">
                        <img src={process.env.PUBLIC_URL + "images/staf/cat6.png"}></img>
                    </li>
                </ul> */}
            </main>



            {/* 예전 푸터 */}
            {/*             <div className="footer_bg">
                <footer>
                <ul className="footer_info">
                    <li><address>주소 | 서울시 관악구 문성로 199-1 2층</address></li>
                    <li>대표 | 고호준</li>
                    <li>개인정보 관리 책임자 | 이형우</li>
                    <li>사업자등록번호 | 469-81-03262</li>
                </ul>
                <ul className="footer_link">
                    <li><Link to={'/Company'}>회사소개</Link></li>
                    <li><Link to={'/agree'} state={{ index : 0}}>이용약관</Link></li>
                    <li><Link to={'/agree'} state={{ index : 1}}>개인정보처리방침</Link></li>
                    <li><Link to={'/agree'} state={{ index : 2}}>위치기반 서비스 이용약관</Link></li>
                </ul>
                <p>Copyright 2023 propmate Inc. all rights reserved.</p>
                </footer>
            </div> */}
        </div>
    );
}

export default People;